import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { updatePhraseBidRemote } from '../../actions/phrases-grid';
import {
    PhraseTrafficForecastCell,
    PhraseTrafficForecastCellProps
} from '../../components/PhraseTrafficFocastCell/PhraseTrafficForecastCell';
import { TrafaretPhrasePriceEditorPopupSaveValue } from '../../components/TrafaretPhrasePriceEditorPopup/TrafaretPhrasePriceEditorPopup';
import { selectGridSourceParams } from '../../selectors/gridSourceParams/gridSourceParams';
import { getEditCellData } from '../../service/GridHelpers/GridHelpers';
import { ConstData } from '../../typings/constants';
import { TrafficVolumeDataItem } from '../../typings/domain';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export type OwnProps = {
    id: string;
    groupId: string;
    cellName: string;
    constants: ConstData;
    currency: string;
    bid: number;
    trafficVolumeData: Array<TrafficVolumeDataItem>;
};

export type StateProps = TStateProps<PhraseTrafficForecastCellProps, OwnProps>;

export type DispatchProps = TDispatchProps<
    PhraseTrafficForecastCellProps,
    OwnProps
>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const { editCellsData, isGridScrolling } = state.grid;
    const { id, cellName, currency, constants } = ownProps;
    const { view } = selectGridSourceParams(state);

    return {
        priceLimit: constants.currencyConstants[currency],
        isGridScrolling,
        ...getEditCellData(editCellsData, id, cellName, view)
    };
};

const mapDispatchToProps = (
    dispatch: Dispatch<Action>,
    ownProps: OwnProps
): DispatchProps => {
    const { cellName, id, groupId } = ownProps;

    return {
        onSave: (value: TrafaretPhrasePriceEditorPopupSaveValue) => {
            dispatch(
                updatePhraseBidRemote(
                    {
                        id,
                        groupId,
                        exactPriceSearch: value.bid
                    },
                    cellName
                )
            );
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): PhraseTrafficForecastCellProps => {
    const { currency, bid, trafficVolumeData } = ownProps;

    return {
        ...{ currency, bid, trafficVolumeData },
        ...stateProps,
        ...dispatchProps
    };
};

export const PhraseTrafficForecastCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    PhraseTrafficForecastCellProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PhraseTrafficForecastCell);
